import { useParams } from 'react-router-dom';

import { NavigateBack } from '../../../designComponents';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import DraftmanJobDetails from './DraftManJobDetails';
// import PrinterJobDetails from './PrinterJobDetails';
import TechnicianJobDetails from './TechnicianJobDetails';

const ViewJobDetails = () => {
  const params = useParams();
  const { jobFor } = params;

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        {jobFor &&
          {
            technician: <TechnicianJobDetails />,
            // printer: <PrinterJobDetails />,
            draftman: <DraftmanJobDetails />,
          }[jobFor]}
      </div>
    </ViewJobContainerStyled>
  );
};

export default ViewJobDetails;
